<template>
  <div>
    <v-select
      v-model="session_id"
      label="Année"
      :items="years"
      item-text="name"
      item-value="id"
      required
    />
    <v-select
      v-model="chosen_area_of_study_id"
      label="Formation"
      :items="areas_of_study"
      item-text="name"
      item-value="id"
      v-if="session_id && areas_of_study.length > 0"
    />
    <v-select
      v-model="chosen_faculty_id"
      label="Section"
      :items="faculties"
      item-text="name"
      item-value="id"
      v-if="session_id && faculties.length > 0"
      required
    />
    <v-select
      v-model="chosen_university_id"
      label="Université"
      :items="universities"
      item-text="name"
      item-value="id"
      clearable
      v-if="chosen_faculty_id && universities && universities.length > 0"
    />
    <v-select
      label="Stage"
      v-model="internship_ids"
      :items="internships"
      item-value="id"
      :item-text="(item) => `${item.name} - ${item.price}€`"
      v-if="chosen_faculty_id && internships.length > 0"
      required
      multiple
      chips
      deletable-chips
    />
    <BaseInfoText
      class="font-weight-bold"
      v-if="internship_ids.length"
    >
      Total : {{ internshipsPrice }} €
    </BaseInfoText>
  </div>
</template>

<script>
import BaseInfoText from '@/components/BaseInfoText.vue';
import {
  chain,
  find, groupBy, sumBy,
} from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'InternshipSignUp',
  created() {
    this.fetchYears();
  },
  components: {
    BaseInfoText,
  },
  watch: {
    internship_ids: {
      handler(newValue) {
        this.$emit('internship-ids-changed', newValue);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['years', 'registrations']),
    ...mapFields(
      'authentication',
      ['form.session_id', 'form.chosen_area_of_study_id', 'form.chosen_faculty_id', 'form.chosen_university_id', 'form.internship_ids'],
    ),
    ...mapGetters(['facultiesByYear']),
    faculties() {
      const facultiesForYear = this.facultiesByYear(this.session_id);
      if (this.chosen_area_of_study_id) {
        return facultiesForYear.filter((faculty) => faculty.area_of_study && faculty.area_of_study.id === this.chosen_area_of_study_id);
      }
      return facultiesForYear.filter((faculty) => !faculty.area_of_study);
    },
    areas_of_study() {
      const facultiesByAreaOfStudy = groupBy(this.facultiesByYear(this.session_id),
        (faculty) => faculty.area_of_study && faculty.area_of_study.name);
      const filteredFaculties = Object
        .entries(facultiesByAreaOfStudy)
        .filter(([, faculties]) => faculties[0].area_of_study);
      return filteredFaculties.map(([name, faculties]) => ({
        name,
        id: faculties[0].area_of_study.id,
      }));
    },
    universities() {
      if (!this.chosen_faculty_id) return [];

      if (this.selectedFaculty && this.selectedFaculty.universities) {
        return this.selectedFaculty.universities;
      }
      return [];
    },
    internships() {
      const studentInternshipIds = this.registrations.map((registration) => registration.internship.id);
      if (this.selectedUniversity) {
        let result = this.selectedUniversity.internships.filter((internship) => !studentInternshipIds.includes(internship.id));
        result = result.filter(
          (internship) => chain(this.selectedFaculty.internships).map('id').includes(internship.id).value(),
        );
        return result;
      }
      if (this.selectedFaculty) {
        return this.selectedFaculty.internships.filter((internship) => !studentInternshipIds.includes(internship.id));
      }
      return [];
    },
    selectedFaculty() {
      return find(this.faculties, { id: this.chosen_faculty_id });
    },
    selectedUniversity() {
      if (this.selectedFaculty) {
        return find(this.selectedFaculty.universities, { id: this.chosen_university_id });
      }
      return null;
    },
    internshipsPrice() {
      return sumBy(this.internships, (internship) => {
        if (this.internship_ids.includes(internship.id)) {
          return internship.price;
        }
        return 0;
      });
    },
  },
  methods: mapActions(['fetchYears']),
};
</script>
